import {
    sendbirdSelectors,
    useSendbirdStateContext,
} from '@sendbird/uikit-react';
import type { SendbirdChatSDK } from '@sendbird/uikit-utils';

import type { SendbirdSdk } from '../types/GuideMessaging';

interface UnloadedSendbirdState {
    stores: { sdkStore: null };
}

type LoadedSendbirdState = ReturnType<typeof useSendbirdStateContext>;

/* We only load the SendbirdProvider for admin users with messaging capabilities. */
const useSafeSendbirdStateContext = ():
    | LoadedSendbirdState
    | UnloadedSendbirdState => {
    try {
        return useSendbirdStateContext();
    } catch (err) {
        return { stores: { sdkStore: null } };
    }
};

export const useSendbird = (): SendbirdSdk => {
    const globalStore = useSafeSendbirdStateContext();
    const sdkStore = globalStore.stores.sdkStore;

    if (sdkStore == null) {
        return { sdk: null as SendbirdChatSDK | null, isLoading: false };
    }

    if (sdkStore.loading || !sdkStore.initialized) {
        return { sdk: null as SendbirdChatSDK | null, isLoading: true };
    }

    const sdkInstance = sendbirdSelectors.getSdk(
        globalStore as LoadedSendbirdState,
    );

    return { sdk: sdkInstance, isLoading: false };
};
